import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=3507db4c&scoped=true&"
import script from "./RichEditor.vue?vue&type=script&lang=js&"
export * from "./RichEditor.vue?vue&type=script&lang=js&"
import style0 from "./RichEditor.vue?vue&type=style&index=0&id=3507db4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3507db4c",
  null
  
)

export default component.exports